<template>
<div class="container">
  <div class="start-screen"  v-if="startScreen">
    <div class="row">
      <div class="col-md-6 d-none d-md-block">
        <img src="images/robot.png" 
             height="300"
             class="robot" 
             alt="Bosch Grow | Robot">
      </div>
      <div class="col-md-6">
        <div class="intro">
          <div class="row">
            <div class="col paragraph">
              <h1 class="header">The intrapreneur quiz. <br>Test yourself!</h1>
              <p class="description">Do I have what it takes to be a successful entrepreneur? Do I think and act entrepreneurially?</p>
              <button class="btn btn-primary" @click="startQuiz">Click here for the Innovation Leader Test</button>
            </div>
          </div>
        </div>        
      </div>
    </div>
  </div>

  <div v-else>

    <div class="result-screen" v-if="showResult">
      <div class="row">
        <div class="col-md-6 d-none d-md-block">
          <img src="images/robot.png" 
               height="300"
               class="robot" 
               alt="Bosch Grow | Robot">
        </div>
        <div class="col-md-6">
          <div class="intro">
            <div class="row">
              <div class="col paragraph">
                <p class="description category">YOUR RESULT: {{ points}} POINTS!</p>
                <p class="description">{{ finalResult.response }}</p>
                <button class="btn btn-primary" @click="reset">Try again</button>
              </div>
            </div>
          </div>        
        </div>
      </div>
    </div>

    <div class="quiz-screen" v-else>
      <h2 class="category question-progress" v-if="answering">Question {{ questionCount + 1 }} of {{ questions.length }}</h2>
      <keep-alive>
        <transition name="component-fade" mode="out-in">
          <component :is="currentComponent" 
                     :questionObject="currentQuestion" 
                     @answer="nextQuestion"></component>
        </transition>
      </keep-alive>
    </div>
  </div>
</div>
</template>

<script>

import ClassicQuest from './ClassicQuest'
import ImageQuest from './ImageQuest'
import AssociationQuest from './AssociationQuest'
import _ from 'underscore'

export default {
  name: 'QuizMaster',
  components: {
    ClassicQuest,
    ImageQuest,
    AssociationQuest
  },
  data() {
    return {
      startScreen: true,
      showResult: false,
      finalResult: null,
      currentComponent: "",
      currentQuestion: null,
      points: 0,
      questionCount: 0,
      questions: [
        { 
          id: 0,
          component: "ImageQuest",
          question: "What suits to you?",
          answers: [
            { letter: "A", 
              answer: "images/questions/GROW_Quiz_Frage_1A.png", 
              response: "This is a courageous decision but we like the idea of throwing something away: 1 Point.", 
              points: 1 
            },
            { letter: "B", 
              answer: "images/questions/GROW_Quiz_Frage_1B.png", 
              response: "Technological affinity, future-oriented and with a sense of humor! 2 Points", 
              points: 2 
            }
          ]
        },
        { 
          id: 1,
          component: "AssociationQuest",
          associatedImage: "images/questions/GROW_Quiz_Frage_2.png",
          question: "What do you think of first?",
          answers: [
            { letter: "A", 
              answer: "A symbol for an idea?",
              response: "Somewhat superficial: 1 Point.", 
              points: 1 
            },
            { letter: "B",
              answer: "The struggle of an inventor?", 
              response: "Good that you don’t just think of Edison: 2 Points.", 
              points: 2 
            },
            { letter: "C",
              answer: "The loss of energy due to heat?",  
              response: "Someone who is efficient and has an environmental mind: 3 Points.", 
              points: 3 
            }
          ]
        },
        { 
          id: 2,
          component: "AssociationQuest",
          associatedImage: "images/questions/GROW_Quiz_Frage_3.png",
          question: "Which text best matches the picture?",
          answers: [
            { letter: "A", 
              answer: "Have I forgotten something?",
              response: "But if you use a knot as a reminder, you should know why: 1 Point", 
              points: 1 
            },
            { letter: "B",
              answer: "Fingertips are more useful than fists or elbows", 
              response: "Exactly, you have a sense for this: 3 Points.", 
              points: 3 
            },
            { letter: "C",
              answer: "This problem I recognize from my shoelaces.",  
              response: "At least it’s honest: 2 Points.", 
              points: 2 
            }
          ]
        },
        { 
          id: 3,
          component: "ImageQuest",
          question: "Who wrote the quote 'Ways are created by walking on them'",
          answers: [
            { letter: "A", 
              answer: "images/questions/GROW_Quiz_Frage_4A.png", 
              response: "Respect Kafka correctly identified. It’s nice when your path leads you to us. Highly deserved: 3 Points.", 
              points: 3 
            },
            { letter: "B", 
              answer: "images/questions/GROW_Quiz_Frage_4B.png", 
              response: "Could have been, but this piece of wisdom is not from Confucius. Nevertheless philosophical: 2 Points.", 
              points: 2 
            },
            { letter: "C", 
              answer: "images/questions/GROW_Quiz_Frage_4C.png", 
              response: "The legendary prankster Eulenspiegel certainly had something in mind, but not that. But for friends with a sense of humor, we have a heart: 1 Point.", 
              points: 1 
            }
          ]
        },
        { 
          id: 4,
          component: "AssociationQuest",
          associatedImage: "images/questions/GROW_Quiz_Frage_5.png",
          question: "What does the Bosch symbolize?",
          answers: [
            { letter: "A", 
              answer: "A double T-anchor (rotor)?",
              response: "Chapeau! You’re right: A full 3 points.", 
              points: 3 
            },
            { letter: "B",
              answer: "The dishwasher start button?", 
              response: "Dishwashers are of course also available from Bosch. But the correct answer is still A. For the technologically savvy: 2 points.", 
              points: 2 
            },
            { letter: "C",
              answer: "A TV set with fat speakers?",  
              response: "Hello?! Already in rest mode? 1 point.", 
              points: 1 
            }
          ]
        },
        { 
          id: 5,
          component: "ImageQuest",
          question: "What was Robert Bosch’s favorite food?",
          answers: [
            { letter: "A", 
              answer: "images/questions/GROW_Quiz_Frage_6A.png", 
              response: "We don't know either. Just for fun, a tasty 2 points", 
              points: 2 
            },
            { letter: "B", 
              answer: "images/questions/GROW_Quiz_Frage_6B.png", 
              response: "We don't know either. Just for fun, a tasty 2 points", 
              points: 2 
            },
            { letter: "C", 
              answer: "images/questions/GROW_Quiz_Frage_6C.png", 
              response: "We don't know either. Just for fun, a tasty 2 points", 
              points: 2 
            }
          ]
        },
        { 
          id: 6,
          component: "ClassicQuest",
          question: "What motivates you the most?",
          answers: [
            { letter: "A", 
              answer: "Money, lots of money!", 
              response: "Pecunia non olet, says the Latin. For an honest answer: 1 point.", 
              points: 1 
            },
            { letter: "B", 
              answer: "Realizing my idea!", 
              response: "The money comes with the success. For the correct order: 2 points.", 
              points: 2 
            }
          ]
        },
        { 
          id: 7,
          component: "AssociationQuest",
          associatedImage: "images/questions/GROW_Quiz_Frage_8.png",
          question: "Who do you recognize in this picture?",
          answers: [
            { letter: "A", 
              answer: "My mother-in-law!",
              response: "You could say that, but look closely again. Until then: 1 point.", 
              points: 1 
            },
            { letter: "B",
              answer: "Two women?", 
              response: "Whether old or young woman - both can be seen here. Sharp eye with imagination deserves a full: 2 points.", 
              points: 2 
            }
          ]
        },
        { 
          id: 8,
          component: "ImageQuest",
          question: "What is 'grow' about?",
          answers: [
            { letter: "A", 
              answer: "images/questions/GROW_Quiz_Frage_9A.png", 
              response: "Logo. But it's not always that easy with us. Friendly: 3 points.", 
              points: 3 
            },
            { letter: "B", 
              answer: "images/questions/GROW_Quiz_Frage_9B.png", 
              response: "If you mean that in the sense of a business idea, then: 1 grace point.", 
              points: 1 
            },
            { letter: "C", 
              answer: "images/questions/GROW_Quiz_Frage_9C.png", 
              response: "Instead of three wishes, you get: 1 fantasy point.", 
              points: 1 
            }
          ]
        },
        { 
          id: 9,
          component: "ClassicQuest",
          question: "How do you answer a child’s question: what is work?",
          answers: [
            { letter: "A", 
              answer: "Work is power x time.", 
              response: "Ok, physically correct: 2 points.", 
              points: 2 
            },
            { letter: "B", 
              answer: "That’s what I do to make money.", 
              response: "You can see it that way, but a little more fantasy would be appropriate. Only: 1 point.", 
              points: 2 
            },
            { letter: "C", 
              answer: "There are many answers, think of one yourself, then I'll tell you mine.", 
              response: "Cool! You and the kid could be something. Excited: 3 points.", 
              points: 2 
            }
          ]
        }
      ],
      results: [
        {
          min: 8,
          max: 13,
          response: "Lateral thinking and courageous decisions are probably your strengths. A sense for reality? That we can teach you."
        },
        {
          min: 14,
          max: 19,
          response: "Almost there. Just come closer: Direction grow ;-)"
        },
        {
          min: 20,
          max: 23,
          response: "You know your way around and are bright. Let's find out if your stomach and heart say yes."
        }
      ]
    }
  },
  computed: {
    answering() {
      return !this.startScreen && !this.showResult
    }
  },
  methods: {
    reset() {
      this.showResult       = false
      this.points           = 0
      this.questionCount    = 0
      this.startScreen      = true
      this.currentQuestion  = ""
      this.currentComponent = ""
    },
    startQuiz() {
      this.points           = 0
      this.questionCount    = 0
      this.startScreen      = false
      this.currentQuestion  = this.questions[0]
      this.currentComponent = this.questions[0].component
    },
    nextQuestion(points) {
      this.questionCount++ 
      if (this.questions.length > this.questionCount) {
        this.points += points
      } else {
        this.points += points
        this.finalResult = _.find(this.results, (obj) => obj.min <= this.points && obj.max >= this.points)
        this.showResult  = true
      }
    }
  },
  watch: {
    questionCount(val) {
      if (this.questions.length > this.questionCount) {
        this.currentQuestion  = this.questions[val]
        this.currentComponent = this.questions[val].component
      }
    }
  }
}
</script>
<style scoped>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .5s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
  }
  .robot {
    float: right;
    margin-right: 30px;
  }
  .intro {
    margin-right: 35px;
    margin-top: 50px;
  }
  .paragraph {
    text-align: left;
    margin-top: 10px;
  }
  .header {
    color: #000000;
    font-size: 2em;
    font-weight: 700;
  }
  .btn-primary {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: none;
    border-radius: 20px;
    padding: 5px 15px;
    text-align: center;
  }
  .btn-primary:hover,
  .btn-primary:focus {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: #fff;
  }
  .description {
    color: #000;
  }
  .category {
    color: #000;
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .question-progress {
    color: #fff;
  }
</style>

